"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHttpTerminator = void 0;
var createHttpTerminator_1 = require("./factories/createHttpTerminator");
Object.defineProperty(exports, "createHttpTerminator", { enumerable: true, get: function () { return createHttpTerminator_1.createHttpTerminator; } });
